import { HttpBackend, HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { DocumentType } from '@app/enums';
import { DocMgmtFile, DocMgmtFileCreate, DocMgmtFileDownload, DocMgmtFiles, DocMgmtMetaData } from '@app/interfaces';

@Injectable()
export class DocManagementService {
	endpointBase = '/api/documents';
	// HttpClient without interceptors or error handling
	pureHttp: HttpClient;

	constructor(private readonly http: HttpClient, private readonly httpBackend: HttpBackend) {
		this.pureHttp = new HttpClient(this.httpBackend);
	}

	listByEntity(documentType: DocumentType, entityId: number | string): Observable<DocMgmtFiles> {
		return this.http.get<DocMgmtFiles>(`${this.endpointBase}/${documentType}/${encodeURIComponent(entityId)}`);
	}

	getEntity(id: string, contentDisposition: 'attachment' | 'inline' = 'inline'): Observable<DocMgmtFileDownload> {
		return this.http.get<DocMgmtFileDownload>(`${this.endpointBase}/${id}`, {
			params: { contentDisposition },
		});
	}

	createEntity(
		documentType: DocumentType,
		entityId: number | string,
		fileName: string,
		metadata: DocMgmtMetaData = {},
		signedUrl: 'PUT' | 'POST' = 'PUT'
	): Observable<DocMgmtFileCreate> {
		return this.http.post<DocMgmtFileCreate>(`${this.endpointBase}/${documentType}/${encodeURIComponent(entityId)}`, {
			name: fileName,
			metadata,
			signedUrl,
		} as DocMgmtFileCreate);
	}

	updateEntity(id: string, fileName: string, metaData?: DocMgmtMetaData): Observable<DocMgmtFile> {
		return this.http.put<DocMgmtFile>(`${this.endpointBase}/files/${id}`, {
			name: fileName,
			metaData,
		});
	}

	updateMetaDataEntity(id: string, Title: string, Description: string, IsConfidential: boolean, IsSendWithEmail: boolean): Observable<DocMgmtFile> {
		return this.http.put<DocMgmtFile>(`${this.endpointBase}/${id}`, {
			MetaData: {
				Description,
				IsConfidential,
				Title,
				IsSendWithEmail,
			},
		});
	}

	uploadToS3(url: string, file: File): Observable<unknown> {
		return this.pureHttp.put(url, file, {
			observe: 'events',
			reportProgress: true,
			headers: {
				'Content-Type': `${file.type}; charset=utf-8`,
			},
		});
	}

	deleteEntity(id: string, permanent = true): Observable<string> {
		const params = permanent ? { permanent } : null;
		return this.http.delete<string>(`${this.endpointBase}/${id}`, { params });
	}
}
